const emailRegex =
  /^(?!\.)(?!.*\.\.)(?!.*\.$)[A-Za-z0-9._%+-]+@(?!(?:[0-9]+\.)+[0-9]+$)(?!-)(?:[A-Za-z0-9-]{1,63}\.)+[A-Za-z]{2,}$/;

export const validateEmail = (email?: string): boolean => {
  if (!email) return true;

  const trimmed = email.toString().trim();

  if (!emailRegex.test(trimmed)) return false;

  const domain = trimmed.split("@")[1];
  const domainParts = domain.split(".") ?? [];
  const tld = domainParts.at(-1);
  const secondLast = domainParts.at(-2);

  const hasRepeatedTLD =
    tld && secondLast && tld.toLowerCase() === secondLast.toLowerCase();

  if (hasRepeatedTLD) return false;

  return true;
};
